import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

/**
 * Elevation schematic for `dorm-bookshelf` (and wide variant).
 *
 * Front: outer frame, side panel thickness lines, horizontal shelf dividers
 * (top, middle, bottom).
 * Side: outer frame, back panel line, shelf depth lines.
 * Right mirrors left.
 *
 * Constants match dormBookshelfRenderer.js.
 */

const IN = 0.0254;
const BOARD_T = 0.75 * IN;
const BACK_T = 0.25 * IN;

export function DormBookshelfSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <g
          transform={
            view === 'right'
              ? `scale(-1, 1) translate(${-depth}, 0)`
              : undefined
          }
        >
          <BookshelfSide
            depth={depth}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </SchematicShell>
    );
  }

  // FRONT VIEW
  const topShelfY = BOARD_T;
  const bottomShelfY = height - BOARD_T;
  const midShelfY = height / 2;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Left side panel inner edge */}
      <Line
        x1={BOARD_T}
        y1={0}
        x2={BOARD_T}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Right side panel inner edge */}
      <Line
        x1={width - BOARD_T}
        y1={0}
        x2={width - BOARD_T}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Top shelf underside */}
      <Line
        x1={BOARD_T}
        y1={topShelfY}
        x2={width - BOARD_T}
        y2={topShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Bottom shelf top edge */}
      <Line
        x1={BOARD_T}
        y1={bottomShelfY}
        x2={width - BOARD_T}
        y2={bottomShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Middle shelf */}
      <Line
        x1={BOARD_T}
        y1={midShelfY}
        x2={width - BOARD_T}
        y2={midShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function BookshelfSide({ depth, height, strokeColor, strokeWidth }) {
  const topShelfY = BOARD_T;
  const bottomShelfY = height - BOARD_T;
  const midShelfY = height / 2;

  return (
    <g>
      {/* Back panel inner edge (vertical line) */}
      <Line
        x1={BACK_T}
        y1={0}
        x2={BACK_T}
        y2={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Top shelf underside */}
      <Line
        x1={BACK_T}
        y1={topShelfY}
        x2={depth}
        y2={topShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Bottom shelf top edge */}
      <Line
        x1={BACK_T}
        y1={bottomShelfY}
        x2={depth}
        y2={bottomShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Middle shelf */}
      <Line
        x1={BACK_T}
        y1={midShelfY}
        x2={depth}
        y2={midShelfY}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

DormBookshelfSchematic.supportsSideViews = true;
